import React from 'react';
import Card from '../Card';
import { useRoomInfoQuery } from '../../../../api/roomInfo';
import RecordBlock from '../RecordBlock';
import {
  roomAcceptanceStatusIdsMap,
  roomStageIdsMap,
  roomStepIdsMap,
} from '../../../../../../constants/room/lifeCycle';
import Btn, { btnTypes } from '../../../../../../components/btn';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import { roomAttachmentModalActions } from '../../../../shared/configs/attachments';
import { useUserAcceptanceRole } from '../../../../shared/hooks/userAcceptanceRole';
import { useRoomAttachmentsQuery } from '../../../../api/roomAttachments';

const emptyArr = [];

const RecordsCard = ({ room }) => {
  const role = useUserAcceptanceRole();

  const { data } = useRoomAttachmentsQuery({
    params: { addressId: room?.id },
  });

  const attachments = Array.isArray(data) ? data : emptyArr;

  return (
    <Card>
      <Card.Header title="Записи" />
      <FetchWrapper addressId={room?.id}>
        <Body room={room} hasVisibleDocsBtn={!!attachments?.length} />
      </FetchWrapper>
      {role.isDirectorOrManager && <Action room={room} />}
    </Card>
  );
};

export default RecordsCard;

function FetchWrapper({ addressId, children }) {
  const { data, isFetching, refetch } = useRoomInfoQuery({
    params: { addressId },
    options: { select: selectFetchDataWrapper },
  });

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg="Не удалось загрузить записи"
    >
      {children}
    </FetchDataWrapper>
  );
}

function Body({ room, hasVisibleDocsBtn }) {
  const { data } = useRoomInfoQuery({
    params: { addressId: room?.id },
    options: { select: selectRecords },
  });

  return (
    <Card.Body>
      {data?.map((record) => (
        <RecordBlock
          key={record.id}
          record={record}
          room={room}
          hasVisibleDocsBtn={hasVisibleDocsBtn}
        />
      ))}
    </Card.Body>
  );
}

function Action({ room }) {
  const { data } = useRoomInfoQuery({
    params: { addressId: room?.id },
    options: { select: selectRecordsWithError },
  });

  const { open } = useModalMethods();

  const unilateralAvailability = checkUnilateralAvailability({
    room,
    records: data,
  });

  const handleClick = () => {
    open(modalNames.attachmentsForm, {
      actionType: roomAttachmentModalActions.setUnilateral,
      room,
      record: unilateralAvailability.record,
    });
  };

  return (
    <Card.Action>
      <Btn
        type={btnTypes.primaryInvert}
        block
        onClick={handleClick}
        disabled={!unilateralAvailability.available}
      >
        Односторонняя передача
      </Btn>
    </Card.Action>
  );
}

function checkUnilateralAvailability({ room, records }) {
  if (
    !room ||
    room.stageAddressLifeCycle?.id !== roomStageIdsMap.acceptance ||
    !Array.isArray(records)
  ) {
    return { available: false };
  }

  const lastRecord = records[records.length - 1];
  const lastStatus = lastRecord?.acceptanceStatusAddressLifeCycle;

  if (!lastStatus) {
    const available =
      room.stepAddressLifeCycle?.id === roomStepIdsMap.ownerNotCome;

    return available ? { available, record: lastRecord } : { available };
  }

  // Когда последний результат приемки Непринято, создается новая запись
  return {
    available: lastStatus.id === roomAcceptanceStatusIdsMap.notAccepted,
  };
}

function selectRecords(data) {
  return data?.acceptances;
}
function selectFetchDataWrapper(data) {
  return data === 'Error' ? data : data?.acceptances;
}

function selectRecordsWithError(data) {
  return Array.isArray(data?.acceptances) ? data.acceptances : data;
}
